import { useEffect } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { getMe } from "app/crud/auth.crud";
import { actions } from "app/store/ducks/auth.duck";

export default function AtualizarSessao() {
    const dispatch = useDispatch();
    const store = useStore();
    const autenticado = useSelector(({ auth: { authToken } }) => !!authToken);

    useEffect(() => {
        if (!autenticado) return;

        getMe()
            .then(({ data }) => {
                const { user, permissions } = data?.data || {};
                if (!user) return;

                dispatch(actions.fulfillUser({ ...store.getState().auth.user, ...user }));
                dispatch(actions.atualizarPermissoes(permissions));
            })
            .catch(() => {});
    }, [autenticado, dispatch]);

    return null;
}
